// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-BrandsContainer----brandsContainer-module---container---1lkho","inner":"src-components-BrandsContainer----brandsContainer-module---inner---13x65 src-styles----global---centredContainer---3bAlq","info":"src-components-BrandsContainer----brandsContainer-module---info---1srnv","brands":"src-components-BrandsContainer----brandsContainer-module---brands---1oVQ6","title":"src-components-BrandsContainer----brandsContainer-module---title---1frNj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BrandsContainer/brandsContainer.module.scss
// module id = 271
// module chunks = 114276838955818